<script>
    import Dropdown       from '../../shared/Dropdown.svelte'
    
    export let inventory
    export let version
    export let disabled = false

    $: options = inventory.versions().map( (version, index) => {
        return { 
            id      : index, 
            value   : version, 
            text    : version
        }
    })

    $: selected = options.find(op => inventory.at(op.value))

    function changed(to) {
        //console.log(to.value, to.value == inventory.info.at)
        version = to.value
    }
</script>

<Dropdown text="versão" {options} {selected} {disabled} onChange={changed}/>